export default "__VITE_ASSET__DbpY7af0__"